
import { defineComponent, inject, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router'
import { app } from '../main';
import { IAreaSelection } from '@/types/IAreaSelection';
import { week_area, month_area } from '../operation_area';

export default defineComponent({
  name: 'HelloWorld',
  props: {
    msg: String,
  },
  setup() {
    const router = useRouter()
    const weeklyAreaTbl = ref()
    const monthlyAreaTbl = ref()
    const AreaSelection: ({ weekly: IAreaSelection[], monthly: IAreaSelection[] } | undefined) = inject('area_selection')
    const handleWeeklyAreaSelectionChange = (val: any) => {
      if(AreaSelection) {
        AreaSelection.weekly = val
      }
    }
    const handleMonthlyAreaSelectionChange = (val: any) => {
      if(AreaSelection) {
        AreaSelection.monthly = val
      }
    }

    const deteilAreas = () => {
      if(AreaSelection) {
        if(AreaSelection.weekly.length > 0 && AreaSelection.monthly.length > 0) {
          app.config.globalProperties.$notify({
            title: 'Warning',
            message: '週稼働エリアと月稼働エリアは同時に選択できません。',
            type: 'warning'
          });
        }else if(AreaSelection.weekly.length + AreaSelection.monthly.length == 0) {
          app.config.globalProperties.$notify({
            title: 'Warning',
            message: 'エリアが選択されていません。',
            type: 'warning'
          });
        }else {
          sessionStorage.setItem('AreaSelection', JSON.stringify(AreaSelection));
          router.push('/map')
        }
      }
    }

    onMounted(() => {
      if(AreaSelection) {
        if(AreaSelection.weekly.length > 0) {
          AreaSelection.weekly.forEach(row => {
            weeklyAreaTbl.value.toggleRowSelection(week_area.find(elem => elem.area == row.area))
          })
        }else {
          weeklyAreaTbl.value.clearSelection()
        }
        if(AreaSelection.monthly.length > 0) {
          AreaSelection.monthly.forEach(row => {
            monthlyAreaTbl.value.toggleRowSelection(month_area.find(elem => elem.area == row.area))
          })
        }else {
          monthlyAreaTbl.value.clearSelection()
        }
      }
    })

    return {
      week_area,
      month_area,
      deteilAreas,
      weeklyAreaTbl,
      monthlyAreaTbl,
      handleWeeklyAreaSelectionChange,
      handleMonthlyAreaSelectionChange
    }
  }
});
